var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgKeyEvent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 89,
  height: 18,
  viewBox: "0 0 89 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M85 0C87.2091 0 89 1.79086 89 4V14C89 16.2091 87.2091 18 85 18H4C1.79086 18 0 16.2091 0 14V4C0 1.79086 1.79086 0 4 0H85Z",
  fill: "black",
  fillOpacity: 0.1
})));
export default SvgKeyEvent;